import { GET_COMMS_REPORT_LIST, GET_COMMS_REPORT_SUCCESS, GET_COMMS_REPORT_ERROR, GET_COMMS_REPORT_EMPTY } from '../../actionType';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetCommsReport = (state = initialState, action) => {
  switch (action.type) {
    case GET_COMMS_REPORT_LIST:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_COMMS_REPORT_SUCCESS:
      state = {
        ...state,
        data: action?.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_COMMS_REPORT_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action?.payload,
      };
      break;

    case GET_COMMS_REPORT_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetCommsReport;
